import React from 'react';
import Hint from './Hint';
import { useStore } from '@/store';

const Overlay = () => {
  const setSortBy = useStore((s) => s.setSortBy);
  const sortBy = useStore((s) => s.sortBy);
  return (
    <header className="overlay">
      <h1>
        국립한글박물관
        <br />
        소장유물 자료
      </h1>
      <p className="title-small">
        <b>크기 비교해보기</b>
      </p>
      <div className="description">
        <p>
          클릭하거나 드래그하며
          <br /> 크기를 비교해 보세요
        </p>
        <img src="/mouse.svg" alt="mouse-icon" />
        <Hint />
        <div className="toggle-button">
          <button
            onClick={() => setSortBy('year')}
            data-active={sortBy === 'year'}
          >
            연도순
          </button>
          <button
            onClick={() => setSortBy('area')}
            data-active={sortBy === 'area'}
          >
            크기순
          </button>
        </div>
      </div>
      <div className="author">
        <a href="https://sungryeol.com">박성렬</a>
        <br />
        <a href="https://sungryeol.com">
          <b>sungryeol.com</b>
        </a>
      </div>
    </header>
  );
};

export default Overlay;
